export const routeMixins = {
  methods: {
    forceUpdate() {
      this.$router.push({ name: 'not existing' })
      this.$router.push({ name: 'pos' })
    }
  }
}
